
import Vue from 'vue';
import AudioPlayerWidget from '@media/components/audio/AudioPlayerWidget.vue';
import Modal from '@core/components/UI/Modal.vue';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  article: ArticleData;
}

interface Data {
  showModal: boolean;
  title: string | null;
}

interface Computed {
  showPlayer: boolean;
  ttsUrl: string | null;
}

interface Methods {
  scrollToPaywall: () => void;
  showTeaserCompleteModal: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    AudioPlayerWidget,
    Modal,
    PianoCustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      title: typeof window !== 'undefined' ? window.document.title.replace('"', '') : null,
    };
  },
  computed: {
    showPlayer() {
      return (
        this.$channelConfig('page').article.component.info.listenIconShow &&
        this.$channelConfig('page').article.component.info.ttsBodyLengthThreshold < this.article.content.body.length &&
        this.article.content.paywall.enabled &&
        this.ttsUrl !== null
      );
    },
    ttsUrl() {
      if (this.$store.state.piano.access.channelAccess && this.article.ttsSettings.textToSpeech !== '') {
        return this.article.ttsSettings.textToSpeech;
      }

      if (this.article.ttsSettings.textToSpeechTeaser !== '') {
        return this.article.ttsSettings.textToSpeechTeaser;
      }

      return null;
    },
  },
  methods: {
    scrollToPaywall() {
      this.showModal = !this.showModal;

      const paywall = document.querySelector('.article-paywall') as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
    showTeaserCompleteModal() {
      this.showModal = !this.showModal;
    },
  },
});
